import { Button, Menu, MenuItem } from "@mui/material";
import { useState } from "react";
import { EXECUTION_TIMELINE_TEMPLATES } from "../constants/product.constants";

export const ExecutionTimelineTemplateSelector = ({
  setFormData,
  isReloadRequired,
  setIsReloadRequired,
}) => {
  const [anchorEl, setAnchorEl] = useState(null);
  const open = Boolean(anchorEl);
  const handleTemplateSelectorClose = () => {
    setAnchorEl(null);
  };
  const handleTemplateSelectorClick = (event) => {
    setAnchorEl(event.currentTarget);
  };
  const handleTemplateSelection = (curSelectedTemplate) => {
    setFormData({ ...curSelectedTemplate });
    setIsReloadRequired(!isReloadRequired);
  };
  return (
    <>
      <Button
        id="basic-button"
        aria-controls={open ? "basic-menu" : undefined}
        aria-haspopup="true"
        variant="contained"
        aria-expanded={open ? "true" : undefined}
        onClick={handleTemplateSelectorClick}
      >
        Predefined Templates
      </Button>
      <Menu
        id="CopyTemplate"
        anchorEl={anchorEl}
        open={open}
        onClose={handleTemplateSelectorClose}
        MenuListProps={{
          "aria-labelledby": "basic-button",
        }}
      >
        {EXECUTION_TIMELINE_TEMPLATES.map((item, index) => (
          <MenuItem
            key={index}
            onClick={() => handleTemplateSelection(item.timeline)}
          >
            {item.name}
          </MenuItem>
        ))}
      </Menu>
    </>
  );
};
